<template>
  <div
    :class="{
      'righttop right-top1 flex1 space-between': true,
      rightTop_newYear: isNewYear,
    }"
  >
    <div class="instruction" @click="openVideo()"></div>
    <div class="bg_center" v-if="isNewYear"></div>
    <div class="left-style flex1">
      
      <img
        class="user-img l"
        v-if="itemurl"
        @click="goPersonCenter"
        :src="itemurl.indexOf('http') != -1 ? itemurl : $apiFileCloud + itemurl"
        alt=""
      />
      <img
        class="user-img l"
        v-if="!itemurl"
        @click="goPersonCenter"
        src="../../../../static/img/samImgPersoanl.png"
        alt=""
      />
      <img
        v-if="isNewYear"
        class="head-img"
        src="../../../../static/newStatic/img/newYear/avatarframe1.png"
        width="64px"
        height="68px"
        alt="头像框"
      />
      <div class="userinfo-style">
        <p class="userName-style flex1">
          <span @click="goPersonCenter" style="cursor: pointer"
            >Hi~ {{ CustomerName }}
          </span>
          <span class="authenticated_status">
            <div>
              <img src="../../../../static/img/ic_rz@2x.png" alt="" />
              <span v-if="loginType == 2">{{ statuName }}</span>
              <span v-if="loginType == 1">{{
                IsAuthenticated == 0
                  ? "未认证"
                  : IsAuthenticated == 1
                  ? "认证中"
                  : "已认证"
              }}</span>
            </div>
          </span>
          <!-- <img
            class="Authenticated"
            :src="
              IsAuthenticated == 2
                ? '../../../../static/img/userInfo/已认证@2x.png'
                : '../../../../static/img/userInfo/未认证@2x.png'
            "
          /> -->
        </p>
        <div class="useriphone flex1">
          <label
            >今天是百运与您相识的第
            <span class="colBlueNow"> {{ RegTime || 0 }} 天，</span
            ><span v-if="!isNewYear">感谢您的支持与相伴</span><span v-if="isNewYear">
              百运网恭祝您：2025年，金蛇开运！

              </span
            ></label
          >
          <span class="jiange">|</span>
          <div
            class="weixin-box"
            @mouseenter="
              () => {
                SalesQrCodeShow = true;
              }
            "
            @mouseleave="
              () => {
                SalesQrCodeShow = false;
              }
            "
          >
            <div class="weixin-box-inner">
              <span class="iphone"> 专属销售 </span>
              <span class="mar8 color333 font600">{{ Salesman }}</span>
              <img
                src="../../../../static/newStatic/img/leftFixedIcon/qywx@2x.png"
                width="16"
                height="16"
                alt="code"
              />
              <span class="mar4 color333">{{ phone }}</span>
            </div>
            <el-collapse-transition>
              <div class="weixin-box-panel" v-show="SalesQrCodeShow">
                <div class="weixin-box-panel__inner" v-show="SalesQrCode">
                  <div class="code">
                    <img
                      :src="SalesQrCode"
                      alt="code"
                      width="162"
                      height="162"
                    />
                  </div>
                  <div class="phone">
                    <div class="phone__inner" @click="copyToClipboard(phone)">
                      <div class="phone__icon"></div>
                      <div class="phone__text">{{ phone }}</div>
                    </div>
                    <div class="phone__tip"></div>
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>

          <div
            class="weixin-box"
            @mouseenter="
              () => {
                CustomerQrCodeShow = true;
              }
            "
            @mouseleave="
              () => {
                CustomerQrCodeShow = false;
              }
            "
          >
            <div class="weixin-box-inner" v-if="Customer">
              <span class="iphone1 marL-16"> 专属客服 </span>
              <span class="mar8 color333 font600">{{ Customer }}</span>
              <img
                src="../../../../static/newStatic/img/leftFixedIcon/qywx@2x.png"
                width="16"
                height="16"
                alt="code"
              />
              <span class="mar4 color333">{{ CustomerMobile }}</span>
            </div>
            <el-collapse-transition>
              <div class="weixin-box-panel" v-show="CustomerQrCodeShow">
                <div class="weixin-box-panel__inner" v-show="CustomerQrCode">
                  <div class="code">
                    <img
                      :src="CustomerQrCode"
                      alt="code"
                      width="162"
                      height="162"
                    />
                  </div>
                  <div class="phone" v-if="CustomerMobile">
                    <div
                      class="phone__inner"
                      @click="copyToClipboard(CustomerMobile)"
                    >
                      <div class="phone__icon"></div>
                      <div class="phone__text">{{ CustomerMobile }}</div>
                    </div>
                    <div class="phone__tip"></div>
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
        </div>
      </div>
    </div>
    <div class="right-style align-items" v-if="loginType == 1">
      <div
        class="zidingyi align-items"
        v-if="!focusState"
        @click="changeWork()"
      >
        <svg-icon name="zidingyi" size="16"></svg-icon>
        <div class="mar4">自定义工作台</div>
      </div>
      <div class="align-items" v-if="focusState">
        <div class="cancel" @click="cancelWork">取消</div>
        <div class="save" @click="saveCoordinate">保存设置</div>
      </div>
    </div>

    <div v-if="showVideo" class="video-class">
      <Video
        :src="videosrc"
        v-if="showVideo"
        :autoplay="true"
        @close="
          () => {
            showVideo = false;
          }
        "
      ></Video>
    </div>
    <div class="bg_right" v-if="isNewYear"></div>
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from "vue";
import bus from "../../../ask/eventBus";
import { fetch, post } from "../../../ask/axios";
import { getCookie, delCookie } from "../../../ask/cookiejs";
import { getDiffDay } from "../../../util/util"
import Video from '../video/index'

export default {
  components: {
    Video
  },
  data() {
    return {

      phone: "",
      Salesman: "" /*业务员姓名*/,
      SalesQrCode: "" /*业务员企业微信二维码*/,
      SalesQrCodeShow: "" /*业务员企业微信二维码*/,
      Customer: "", //专属客服昵称
      CustomerQQ: "", //专属客服QQ
      CustomerMobile: "", //专属客服电话
      CustomerQrCode: "", //专属客服企业微信二维码
      CustomerQrCodeShow: "", //专属客服企业微信二维码
      LoginName: "",
      IsAuthenticated: 0,//是否认证  2为已认证

      api: {
        url: "",
        param: "",
        response: {},
        message: "",
      },

      itemurl: "",
      CustomerName: "",
      InformationInfo: [],
      InforMationSum: "",
      show: false,
      focusState: false,
      isTrueShow: false,
      Coordinate: [],
      // CoordinateX: [],//自定义工作台模块坐标X轴
      // CoordinateY: [],//自定义工作台模块坐标y轴
      // CoordinateName: [],//自定义工作台模块名字
      RegTime: '',
      loginType: "",
      noSave: null,//是否取消保存
      statuName: "",
      showVideo: false,
      videosrc: '',
    };
  },
  directives: {

  },

  created() {
    //this.initfunction();
    //发射账号数据
  },
  watch: {},
  mounted() {

    //接收工作台模块传过来的模块信息
    bus.$on("updatedLayout", (val, isName) => {
      console.log("isName", isName);
      if (isName) {
        this.Coordinate = val.map((item) => {
          return { x: item.x, y: item.y, i: item.i, name: item.name.name, w: item.w, h: item.h }
        })
        console.log("Coordinate", this.Coordinate);
      } else {
        this.Coordinate = val.map((item) => {
          return { x: item.x, y: item.y, i: item.i, name: item.name, w: item.w, h: item.h }
        })
      }

    });
    // bus.$on("SalesInfos", (val) => {
    //   if (val.RootCustomerInfo) {
    //     this.itemurl = val.RootCustomerInfo.UserHeadImg;
    //   } else {
    //     this.itemurl = val.UserHeadImg;
    //   }
    //   this.LoginName = val.LoginName;
    //   this.phone = val.SalesMobile;
    //   this.Salesman = val.SalesName;
    //   this.Customer = val.KFNiName;
    //   this.CustomerQQ = val.KFQQ;
    //   this.loginType = val.LogInType
    //   this.IsAuthenticated = val.IsAuthenticated
    //   this.CustomerName = val.CustomerName;
    //   this.RegTime = getDiffDay(val.RegTime, new Date())
    // })
    let loginInfos = JSON.parse(sessionStorage.getItem("loginMessage"));
    console.log(22222, loginInfos);
    if (loginInfos.RootCustomerInfo) {
      this.itemurl = loginInfos.RootCustomerInfo.UserHeadImg;
      this.statuName = loginInfos.RootCustomerInfo.CustomerName
    } else {
      this.itemurl = loginInfos.UserHeadImg;
    }
    this.LoginName = loginInfos.LoginName;
    this.phone = loginInfos.SalesMobile;
    this.Salesman = loginInfos.SalesName;
    this.SalesQrCode = loginInfos.SalesQrCode;
    this.Customer = loginInfos.KFName;
    this.CustomerQQ = loginInfos.KFQQ;
    this.CustomerMobile = loginInfos.KFMobile;
    this.CustomerQrCode = loginInfos.KFQrCode;
    this.loginType = loginInfos.LogInType
    this.IsAuthenticated = loginInfos.IsAuthenticated
    this.CustomerName = loginInfos.CustomerName;
    this.RegTime = getDiffDay(loginInfos.RegTime, new Date())


  },
  methods: {
    copyToClipboard(text) {
      var textarea = document.createElement('textarea');
      textarea.style.position = 'fixed';
      textarea.style.opacity = 0;
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    },
    openVideo() {

      this.showVideo = true;
      this.videosrc = this.$apiFileCloud + this.$apiFileCloudFirst + '/platformvideo/7.mp4'
    },
    //点击头像及用户名跳转个人中心
    goPersonCenter() {
      window.location.href = '/myInfo/personalCenter'
    },
    // 保存自定义工作台设置
    saveCoordinate() {
      // this.$apiGateWay
      let url = this.$api04 + "Basics/api/Customer/UPPageConsole"
      console.log(33);
      var CoordinateArr = []

      for (let i = 0; i < this.Coordinate.length; i++) {
        CoordinateArr.push({ ModuleID: this.Coordinate[i].i, ModuleName: this.Coordinate[i].name, x: this.Coordinate[i].x, y: this.Coordinate[i].y, w: this.Coordinate[i].w, h: this.Coordinate[i].h })
      }
      console.log("CoordinateArr", CoordinateArr);
      if (!CoordinateArr.length) {
        return this.$message("您没有移动工作台位置!"), this.focusState = false, bus.$emit("customWorkbench", false)
      }
      post(url, CoordinateArr).then((res) => {

        if (res.IsOK) {
          this.$message.success(res.Message)
        } else (
          this.$message.error(res.Message)
        )
      })
      this.focusState = false
      this.noSave = false
      bus.$emit("customWorkbench", false, this.noSave)
    },
    changeWork() {
      this.focusState = true
      bus.$emit("customWorkbench", true)
    },
    // 取消自定义工作台
    cancelWork() {
      this.noSave = true
      this.focusState = false
      bus.$emit("customWorkbench", false, this.noSave)

    },
    // initfunction() {
    //   let that = this;
    //   this.api.url = this.$api02 + "/api/CustomerInfo/GetCustomerInfoByToken";
    //   this.api.param = {};
    //   post(this.api.url, this.api.param).then((res) => {
    //     if (res.Results) {
    //       that.LoginName = res.Results.LoginName;

    //       //如果是子账号登录，则显示主账号的信息 RootCustomerInfo
    //       if (res.Results.RootCustomerInfo) {
    //         that.itemurl = res.Results.RootCustomerInfo.UserHeadImg;
    //       } else {
    //         that.itemurl = res.Results.UserHeadImg;
    //       }

    //       that.phone = res.Results.SalesMobile;
    //       that.Salesman = res.Results.SalesName;
    //       that.Customer = res.Results.KFNiName;
    //       that.CustomerQQ = res.Results.KFQQ;
    //       that.loginType = res.Results.LogInType
    //       that.IsAuthenticated = res.Results.IsAuthenticated
    //       that.CustomerName = res.Results.CustomerName;
    //       // console.log("res.Results", res.Results);
    //       //用户信息对象
    //       sessionStorage.setItem("SalesInfos", JSON.stringify(res.Results));
    //       that.RegTime = getDiffDay(res.Results.RegTime, new Date())
    //       //that.UnreadInformation();

    //     }
    //   });
    // },
  },
  beforeDestroy() {
    // bus.$off("SalesInfos")
  }
}
</script>

<style lang="scss" type="text/css" rel="stylesheet" scoped="scoped">
.flex1 {
  display: flex;
}
.space-between {
  justify-content: space-between;
}
.marL-16 {
  margin-left: 16px;
}
.mar4 {
  margin: 0 4px;
}
.mar8 {
  margin: 0 8px;
}
.color333 {
  color: #333333;
}
.mar10 {
  margin: 0 10px;
}

.font600 {
  font-weight: 600 !important;
}
.hover-public {
  background: rgba(0, 70, 185, 0.04);
  border: 1px solid rgba(0, 70, 185, 0.8);
  transition: all 0.3s;
}
.active-public {
  background: rgba(0, 70, 185, 0.08);
  border: 1px solid #0046b9;
}

.righttop {
  height: 96px;
  background: #ffffff;
  //width: calc(100vw - 200px);
  min-width: 1240px;
  // margin-bottom: 24px;
  z-index: 99;
  .instruction {
    position: absolute;
    right: 0px;
    width: 86px;
    height: 24px;
    background: #ffffff;
    cursor: pointer;
    background-image: url("../../../../static/newStatic/img/video/pic_gzt_bksm_nor@2x.png");
    background-size: 86px 24px;
    &:hover {
      background-image: url("../../../../static/newStatic/img/video/pic_gzt_bksm_hover@2x.png");
    }
    &:active {
      background-image: url("../../../../static/newStatic/img/video/pic_gzt_bksm_click@2x.png");
    }
  }
  .bg_center {
    width: 400px;
    height: 104px;
    left: 50%;
    // margin-left: -387px;
    top: 0;
    transform: translateX(-50%);
    position: absolute;
    background: url("../../../../static/newStatic/img/newYear/topBgCenter1.png");
    background-size: 400px 104px;
  }
  .left-style {
    font-family: PingFangSC-Semibold, PingFang SC;
    background: url("../../../../static/img/userInfo/左@2x.png");
    background-size: 100% 96px;
    .user-img {
      width: 56px;
      height: 56px;
      margin: 20px 0 20px 24px;
      cursor: pointer;
      border-radius: 30px;
    }
    .userinfo-style {
      padding: 23px 8px;
      .userName-style {
        font-size: 18px;

        font-weight: 600;
        color: #333333;
        line-height: 22px;
        .Authenticated {
          width: 60px;
          height: 22px;
          margin-left: 8px;
        }
      }
      .useriphone {
        margin-top: 9px;
        font-size: 13px;
        font-weight: 400;
        color: #777777;
        line-height: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        .jiange {
          margin: 0 16px;
        }
        .iphone {
          padding: 2px 6px;
          width: 60px;
          height: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 11px;
          color: #0046b9;
          line-height: 16px;
          font-style: normal;
          text-align: center;
          background: rgba(0, 70, 185, 0.08);
          border-radius: 4px;
          box-sizing: border-box;
        }

        .iphone1 {
          padding: 2px 6px;
          width: 60px;
          height: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 11px;
          color: #4d1ed9;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-align: center;

          background: rgba(77, 30, 217, 0.08);
          border-radius: 4px;
          box-sizing: border-box;
        }

        .weixin-box {
          position: relative;
          z-index: 999;
          .weixin-box-inner {
            display: flex;
            align-items: center;
          }

          .weixin-box-panel {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            .weixin-box-panel__inner {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 250px;
              height: 308px;
              background: url("../../../../static/newStatic/img/leftFixedIcon/pic_bg_qw_xs@2x.png")
                no-repeat;
              background-size: 250px 308px;

              .code {
                margin-top: 56px;
                padding: 10px;
                width: 184px;
                height: 184px;
                background: #ffffff;
                border-radius: 12px;
                border: 1px solid rgba(32, 109, 234, 0.16);
                box-sizing: border-box;
              }

              .phone {
                position: relative;
                margin-top: 12px;
                .phone__inner {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .phone__icon {
                    width: 16px;
                    height: 16px;
                    background: url("../../../../static/newStatic/img/leftFixedIcon/ic_tel_default@2x.png");
                    background-size: 16px 16px;
                    translate: all 0.3s;
                  }

                  .phone__text {
                    margin-left: 8px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 13px;
                    color: #333333;
                    line-height: 18px;
                    text-align: left;
                    font-style: normal;
                    translate: all 0.3s;
                  }

                  &:hover {
                    cursor: pointer;
                    .phone__icon {
                      width: 16px;
                      height: 16px;
                      background: url("../../../../static/newStatic/img/leftFixedIcon/ic_tel_hover@2x.png");
                      background-size: 16px 16px;
                    }
                    .phone__text {
                      color: #0046b9;
                    }
                  }
                }

                .phone__tip {
                  position: absolute;
                  opacity: 0;
                  width: 112px;
                  height: 32px;
                  background: url("../../../../static/newStatic/img/leftFixedIcon/phoneTip.png");
                  background-size: 112px 32px;
                  visibility: hidden;
                  transition: all 0.3s;
                }

                &:hover {
                  .phone__tip {
                    opacity: 1;
                    visibility: visible;
                  }
                }
              }
            }
          }

          &:hover {
            .weixin-box-panel {
            }
          }
        }
      }
    }
  }
  .right-style {
    padding-right: 24px;
    background: url("../../../../static/img/userInfo/右@2x.png");
    background-size: 100% 96px;
    height: 96px;
    .zidingyi {
      width: 126px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(0, 70, 185, 0.4);
      color: #0046b9;
      font-size: 14px;
      font-weight: 550;
      cursor: pointer;
      &:hover {
        @extend .hover-public;
      }
      &:active {
        @extend .active-public;
      }
    }
    .cancel {
      width: 56px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(0, 70, 185, 0.4);
      font-size: 14px;
      color: #0046b9;
      font-weight: 550;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
      &:hover {
        @extend .hover-public;
      }
      &:active {
        @extend .active-public;
      }
    }
    .save {
      width: 88px;
      height: 32px;
      background: #0046b9;
      border-radius: 4px;
      font-weight: 500;
      color: #ffffff;
      font-size: 14px;
      line-height: 32px;
      text-align: center;
      margin-left: 8px;
      cursor: pointer;
      &:hover {
        background: rgba(0, 70, 185, 0.8);
      }
      &:active {
        background: rgba(0, 70, 185, 1.6);
      }
    }
  }
}

.rightTop_newYear {
  height: 104px;
  background: linear-gradient( 180deg, #FFF0F0 0%, #FFFFFF 100%);
  position: relative;
  .head-img {
    position: absolute;
    left: 22px;
    top: 10px;
  }

  .left-style {

    background: none;
    // background-size: 48px 96px;
    // background-repeat: no-repeat;
    position: relative;
    background: url("../../../../static/newStatic/img/newYear/rightTopLeft@2x.png") no-repeat;
      background-size: 72px 80px;
      background-position: left top;

    
    .userinfo-style {
      // background: url("../../../../static/newStatic/img/newYear/切图-中@2x.png");
      // background-size: 774px 96px;
      // background-repeat: no-repeat;
    }
  }

  // .right-style {
  //   background: url("../../../../static/newStatic/img/newYear/topBgRight.png");
  //   background-size: 200px 96px;
  //   background-repeat: no-repeat;
  // }
  .bg_right {
    background: url("../../../../static/newStatic/img/newYear/topBgRight1.png");
    background-size: 160px 104px;
    background-repeat: no-repeat;
    position: absolute;
    width: 160px;
    height: 104px;
    right: 0;
    top: 0;
    z-index: -1;
  }
}
.align-items {
  display: flex;
  justify-content: center;
  align-items: center;
}
.authenticated_status {
  display: inline-block;
  // width: 56px;
  height: 18px;
  background: rgba(0, 70, 185, 0.12);
  border-radius: 11px;
  // padding-right: 10px;
  position: relative;
  left: 15px;
  top: 2px;
  div {
    display: flex;
    align-items: center;
    position: relative;
    bottom: 1px;
    img {
      width: 17px;
      height: 14px;
      position: absolute;
      left: -10px;
      top: 3px;
      margin: 0px 2px;
    }
    span {
      display: inline-block;
      font-size: 10px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0046b9;
      margin: 0 7px 0 12px;
      height: 14px;
      line-height: 18px;
    }
  }
}
.video-class {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  //opacity: .5;
  background: rgba(0, 0, 0, 0.24);
  text-align: center;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/public/rightTop.vue